import * as React from 'react'

import * as plume from '@ulule/owl-kit-components/next'

import { useMessage } from '../useMessage'

type BannerProps = {
  className?: string
  contexts?: string[]
}

export function Banner({ className, contexts = [] }: BannerProps): React.ReactElement<BannerProps> {
  const { messages, clearMessages } = useMessage(contexts)

  return (
    <>
      {messages.map((message) => {
        const { context, level, message: content } = message
        return (
          <plume.Banner
            className={className}
            key={context}
            onClose={() => clearMessages(context)}
            type={level === 'error' ? 'alert' : level}
          >
            {content}
          </plume.Banner>
        )
      })}
    </>
  )
}
